<template>
  <div v-if="isMobile && isPageValid">
    <!-- NOTE ON THE BELOW -
        This may seem redundant but I needed to add a height of the button section element on the page without showing it,
        because as soon as the footer is in view, the button switches positions from fixed to relative,
        this worked fine however there was a bug GLITCH at the moment the footer becomes into view,
        this was happening because the height of the main div would change as the button was added to the view,
        once the main div changed then the footer position changed, causing a recursive loop, between it being visible and not visible,
        so the fix was to add this to the page height but not show it, as the button is fixed,
        then remove it from the view once the button was visible, this does not work on using just one object
        in the dom therefore the hack below eventually fixed it so please do not change this implementation below
        -->
    <div v-if="isMobile && !isFooterinView && isPageValid" class="search__mobile" style="visibility:hidden">
      <div class="search__mobile--buttons">
        <div class="search__mobile--buttons-display">
          <button class="btn-primary-dark-md">
            {{ label }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="isMobile && isPageValid" class="search__mobile">
      <div class="search__mobile--buttons" :style="getButtonStyle">
        <div class="search__mobile--buttons-display">
          <app-link :id="linkID" type="page">
            <button class="btn-primary-dark-md">
              {{ label }}
            </button>
          </app-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import responsive from '../mixins/responsive.js';
import { MSB_EXCLUDED_TEMPLATE_IDS, MSB_EXCLUDED_PAGE_IDS } from '../constants/templates.js';

export default {
  name: 'MobileSearch',
  mixins: [
    responsive,
  ],
  props: {
    label: { type: String, default: 'Search villas' },
    linkID: { type: [String, Number], default: 16 },
  },
  data() {
    return {
      EXCLUDED: MSB_EXCLUDED_TEMPLATE_IDS,
      EXCLUDEDPAGES: MSB_EXCLUDED_PAGE_IDS,
    };
  },
  computed: {
    isPageValid() {
      return !this.EXCLUDED.includes(this.currentTemplateID) && !this.isCurrentPageSecure && !this.EXCLUDEDPAGES.includes(this.currentPageID);
    },
    currentPage() {
      return this.$store.getters['pages/currentPage'];
    },
    currentTemplateID() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].templateId : 0;
    },
    currentPageID() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].id : 0;
    },
    isCurrentPageSecure() {
      return this.$store.getters['pages/isCurrentPageSecure'];
    },
    isFooterinView() {
      return this.$store.getters['filterbar/getFooterInView'];
    },
    getButtonStyle() {
      return {
        position: this.isFooterinView ? 'relative' : 'fixed',
        bottom: this.isFooterinView ? null : '0px',
        top: this.isFooterinView ? '0px' : null,
      };
    },

  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings/config.scss";

.search__mobile {
    &--buttons {
      width: 100%;
      position:relative;
      left:0px;
      z-index: 5;
      background: $stoneWhite;
      border-top: solid 1px $solitude;
      &-display {
        // margin: 1em;
        button {
          margin: 0;
          width:100%;
        }
      }
    }
}

</style>
